import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Coffee = createReactComponent("Coffee", ["svg", defaultAttributes, [["path", {
  d: "M18 8h1a4 4 0 010 8h-1",
  key: "g6jb7s"
}], ["path", {
  d: "M2 8h16v9a4 4 0 01-4 4H6a4 4 0 01-4-4V8z",
  key: "1t67t2"
}], ["line", {
  x1: "6",
  y1: "1",
  x2: "6",
  y2: "4",
  key: "1w7hat"
}], ["line", {
  x1: "10",
  y1: "1",
  x2: "10",
  y2: "4",
  key: "zjoenp"
}], ["line", {
  x1: "14",
  y1: "1",
  x2: "14",
  y2: "4",
  key: "1s8gwc"
}]]]);
export default Coffee;